<template>
  <div class="sell-page">
    <div class="sell-page-container">
      <div class="sell-page-header">
        <h1 v-html="focus.cartouche ? focus.cartouche.titre : ''"></h1>
        <p v-html="focus.cartouche ? focus.cartouche.texte : '' "></p>
        <h2 v-html="focus.paragraphe1 ? focus.paragraphe1.titre : ''"></h2>
        <p v-html="focus.paragraphe1 ? focus.paragraphe1.texte : '' "></p>
        <img :src="focus.paragraphe1 ? focus.paragraphe1.image : ''" alt="graphique vente d'un bien">
      </div>
      <div class="sell-page-form-container">
        <h4 v-html="focus.paragraphe2 ? focus.paragraphe2.titre : '' "></h4>
        <p v-html="focus.paragraphe2 ? focus.paragraphe2.texte : '' "></p>

        <div class="text-center font-weight-bold m-5" v-if="formSent"
          v-html="focus.paragraphe4 ? focus.paragraphe4.texte : 'Le formulaire a bien été envoyé.'">
        </div>
        <form v-else @submit.stop.prevent="sendData" class="sell-page-form">
          <div>
            <div class="sell-page-form-field-container flex-column">
              <div class="sell-page-form-field ">
                <el-select v-model="fiche.civilite" placeholder="Civilité" id="civilite" name="civilite"
                  required><el-option v-for="(item, idx) in civilitesOptions" :key="idx" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
                <label for="civilite">Civilité</label>
              </div>
              <div class="sell-page-form-field ">
                <input id="nom" name="nom" placeholder="Votre nom" v-model="fiche.nom" required />
                <label for="nom">Nom</label>
              </div>
              <div class="sell-page-form-field ">
                <input id="prenom" name="prenom" placeholder="Votre prénom" v-model="fiche.prenom" required />
                <label for="prenom">Prénom</label>
              </div>
              <div class="sell-page-form-field ">
                <input id="email" name="email" placeholder="Votre email" v-model="fiche.email" required />
                <label for="email">Email</label>
              </div>
              <div class="sell-page-form-field ">
                <input id="telephone" name="telephone" placeholder="Votre telephone" v-model="fiche.telephone" />
                <label for="telephone">Téléphone</label>
              </div>
            </div>
            <div class="sell-page-form-field-container flex-column">
              <div class="sell-page-form-field ">
                <el-select v-model="fiche.type" placeholder="Type de bien" id="type" name="type" required><el-option
                    v-for="(item, idx) in typeBienOptions" :key="idx" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
                <label for="type">Type du bien</label>
              </div>
              <div class="sell-page-form-field ">
                <el-select v-model="fiche.secteur" placeholder="Secteur du bien" id="secteur" name="secteur"
                  required><el-option v-for="(item, idx) in secteurOptions" :key="idx" :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
                <label for="secteur">Secteur du bien</label>
              </div>
              <div class="sell-page-form-field ">
                <AutoCompleteGouvApi @changedGPSData="changeGPSData"></AutoCompleteGouvApi>
                <label for="Localisation">Lieu</label>
              </div>
              <div class="sell-page-form-field ">
                <input id="surface" name="surface" placeholder="Surface" v-model="fiche.surface" required />
                <label for="surface">Surface</label>
              </div>
              <div class="sell-page-form-field ">
                <input id="surfaceHabitable" name="surfaceHabitable" placeholder="Surface Habitable"
                  v-model="fiche.surfaceHabitable" required />
                <label for="surfaceHabitable">Surface Habitable</label>
              </div>
              <div class="sell-page-form-field ">
                <input id="surfaceTerrain" name="surfaceTerrain" placeholder="Surface Terrain"
                  v-model="fiche.surfaceTerrain" required />
                <label for="surfaceTerrain">Surface Terrain</label>
              </div>
              <div class="sell-page-form-field ">
                <input id="prix" name="prix" placeholder="Prix souhaité" v-model="fiche.prix" required />
                <label for="prix">Prix</label>
              </div>
            </div>
            <div class="sell-page-form-field-container flex-column">
              <div class="sell-page-form-field ">
                <textarea id="description" name="description" placeholder="Description de votre bien en quelques lignes"
                  v-model="fiche.description" rows="15" required>
              </textarea>
                <label for="description">Description du bien</label>
              </div>
              <div class="sell-page-rgpd-field ">
                <input type="checkbox" id="conditionsRgpd" v-model="fiche.rgpd" name="conditionsRgpd" value="1"
                  unchecked-value="0" required />
                <p v-html="focus.paragraphe3 ? focus.paragraphe3.texte : ' '"></p>
              </div>
            </div>
          </div>
          <div class="sell-page-form-submit-container">
            <strong>* champs obligatoires</strong>
            <input class="cg-btn cg-btn-primary" type="submit" value="Envoyer" />
          </div>
        </form>

      </div>
    </div>
  </div>
</template>

<script>
import DataApi from 'fm-data-api'
import lozad from 'lozad'
import { getFocus } from '../../mixins/getFocus'

const observer = lozad() // lazy loads elements with default selector as '.lozad'
observer.observe()

export default {
  name: 'Sell',
  mixins: [getFocus],
  components: {
    AutoCompleteGouvApi: () => import('../../components/AutoCompleteGouvApi')
  },
  data() {
    return {
      civilitesOptions: [
        {
          id: 1,
          label: 'Madame',
          value: 'Madame'
        },
        {
          id: 2,
          label: 'Monsieur',
          value: 'Monsieur'
        }
      ],
      typeBienOptions: [
        { id: 1, value: 'Maison / Villa', label: 'Maison / Villa' },
        { id: 2, value: 'Appartement', label: 'Appartement' },
        { id: 3, value: 'Terrain', label: 'Terrain' },
        { id: 4, value: 'Commerce', label: 'Commerce' },
        { id: 5, value: 'Bureau / Local commercial', label: 'Bureau / Local commercial' },
        { id: 6, value: 'Parking', label: 'Parking' },
        { id: 7, value: 'Immeuble', label: 'Immeuble' },
        { id: 8, value: 'Hangar', label: 'Hangar' },
        { id: 9, value: 'Hôtel particulier', label: 'Hôtel particulier' },
        { id: 10, value: 'Droit au bail', label: 'Droit au bail' },
        { id: 11, value: 'Divers', label: 'Divers' }
      ],
      secteurOptions: [
        { id: 1, label: 'Centre-ville', value: 'Centre-ville' },
        { id: 2, label: 'Périphérie', value: 'Péripherie' }
      ],
      fiche: {
        civilite: 'Madame',
        nom: null,
        prenom: null,
        email: null,
        telephone: '',
        type: 'Maison / Villa',
        secteur: 'Centre-ville',
        surface: null,
        surfaceHabitable: null,
        surfaceTerrain: null,
        prix: null,
        description: null,
        rgpd: null
      },
      formSent: false,
      focus: {}
    }
  },
  methods: {
    changeGPSData(centre) {
      this.fiche.lieu = centre.commune
    },
    async sendData() {
      const bienToSend = this.fiche
      const options = {
        apiUrl: this.$apiUrl,
        databaseName: this.$databaseName,
        token: await this.$getMainToken()
      }
      this.dataApi = new DataApi(options)
      this.dataApi.createRecord('W_BienAEvaluer', bienToSend)
        .then((response) => {
          console.log(response)
          this.formSent = true
        })
    },
  },
  async beforeMount() {
    await this.getFocus('ti', 'Vendre')
      .then(res => {
        this.focus = res
      })
  }
}

</script>

<style lang="scss" scoped>
.sell-page {
  background-color: var(--color-background-light-grey);
  color: black;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 16px;

  .sell-page-container {
    max-width: var(--max-width);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
}

.sell-page-header {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  margin: 24px 0px;
  width: 100%;

  p {
    font-size: 1.1rem;
    font-weight: 300;
    text-align: start;
  }

  img {
    width: 100%;
    height: auto;
    margin: 24px 0;
  }
}

.sell-page-form-container {
  max-width: var(--max-width);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  background-color: #fff;
  width: 100%;
  margin: 24px 0;

  h4 {
    margin: 24px 16px;
  }

  .sell-page-form {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;

    &>div {
      display: flex;
      align-items: flex-start;
      justify-content: center;
      flex-wrap: wrap;
      width: 100%;
    }

    .sell-page-form-field-container {
      display: flex;
      flex-direction: column;

      .sell-page-form-field {
        display: flex;
        flex-direction: column-reverse;
        align-items: flex-start;
        margin: 16px;

        input {
          height: 48px;
          width: 250px;
        }

        input,
        textarea {
          padding: .5rem 1rem;
          line-height: 1.5;
          border-radius: .3rem;
          border: 1px solid #ced4da;
          font-size: 0.8rem;
          font-weight: 600;

          &::placeholder {
            color: #C0C4CC;
          }
        }

        input:focus-visible,
        textarea:focus-visible {
          outline: 2px solid var(--color-primary);
        }

        label {
          margin: 0;
        }

        textarea {
          resize: none;
          max-width: 400px;
          width: 100%;
        }

        *:required~label::after {
          content: '*';
        }
      }
    }

    .sell-page-rgpd-field {
      display: flex;
      margin: 16px;
      max-width: 400px;

      p {
        margin: 16px;
      }
    }

    .sell-page-form-submit-container {
      margin: 16px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }

    .cg-btn {
      height: 50px;
      width: 250px;
      display: block;
      margin: 16px;
    }
  }
}
</style>
